export const mapsText = {
    searchBox: 'Search Box'
}
